<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <!-- <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="http://bu-dmc.hkbu.edu.hk/images/logo/comp.png"
          width="200"
        />
      </div>-->

      <v-spacer></v-spacer>

      <v-btn text to="/">Home</v-btn>
      <v-btn text to="/login">Login (for Development only)</v-btn>
      <!-- <v-btn text to="/new">New</v-btn>
      <v-btn text to="/edit">Edit</v-btn>
      <v-btn text to="/next">Next</v-btn>-->
      <v-btn text to="/InCourses">Instructor's Dashboard</v-btn>
      <v-btn text to="/StuCourses">Student's Dashboard</v-btn>

      <v-spacer></v-spacer>

      <!-- <v-btn href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank" text>
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>-->
    </v-app-bar>

    <v-content>
      <!-- <HelloWorld/> -->
      <router-view />
    </v-content>
    <v-footer>
      <v-spacer>
        Best viewed in Chrome.
      </v-spacer>
      <div>HKBU CS &copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';

export default {
  name: "App",

  // components: {
  //   HelloWorld,
  // },

  data: () => ({
    //
    bottomNav: "recent"
  })
};
</script>

